import { render, staticRenderFns } from "./CorpAuthNotify.vue?vue&type=template&id=9378c858&"
import script from "./CorpAuthNotify.vue?vue&type=script&lang=ts&"
export * from "./CorpAuthNotify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports